import { makeAutoObservable, runInAction } from 'mobx'
import { http } from '@/utils'

class EnterpriseStore {

    //数据列表初始化
    dataList = [];

    selectList = [];

    //总条数
    total = '';

    //条数
    pagesize = 10;

    //当前页
    page = 1;

    //表单收集
    valueData = {
        jd: 43,
        wd: 125
    }
    isJdWd = false
    //弹框状态初始化
    isActive = false

    //弹框名字
    title = ''

    //查询字段
    qymc = ''

    //批量删除
    moreId = ''

    //用户id
    jrxtid = JSON.parse(window.localStorage.getItem('jrxtid')) || ''


    //城市联动code
    AreaCode = ''
    //五极联动
    province = []//省
    provinceValue = ''

    city = [] //市
    cityValue = ''

    county = []//县
    countyValue = ''

    township = []//乡
    townshipValue = ''

    village = []//村
    villageValue = ''

    constructor() {
        makeAutoObservable(this)
    }

    //下拉
    getSelectList = async () => {
        const res = await http.get(`/adminapi/systemmanagement?page=${1}&pagesize=${5000}&jrxtid=${this.jrxtid}`)
        if (res.data.code === 200) {
            runInAction(() => {
                let newdata = []
                JSON.parse(JSON.stringify(res.data.data.data.data)).forEach((item) => {
                    let newObj = {}
                    newObj.value = item.id
                    newObj.label = item.xtmc
                    newdata.push(newObj)
                    return newdata
                })
                this.selectList = newdata
            })
        }
    }

    //数据获取
    getDataList = async () => {
        const res = await http.get(`/adminapi/enterprisemanagement?page=${this.page}&pagesize=${this.pagesize}&qymc=${this.qymc}`)
        if (res.data.code === 200) {
            runInAction(() => {
                this.dataList = JSON.parse(JSON.stringify(res.data.data.data.data))
                this.total = res.data.data.data.total
            })
        }
    }

    //删除
    getDeleteButtom = async (id) => {
        const res = await http.delete(`/adminapi/enterprisemanagement/${id}`)
        if (res.status) {
            this.getDataList()
        }
    }

    //添加
    getAddButtom = async (values) => {
        const res = await http.post(`/adminapi/enterprisemanagement`, values)
        if (res.status === 200) {
            this.getDataList()
        }
    }

    //修改
    getPutInformation = async (values) => {
        const res = await http.put(`/adminapi/enterprisemanagement/${this.valueData.aid}`, values)
        if (res.status === 200) {
            this.getDataList()
        }
    }


    // 五级联动 
    cityList = (data) => {
        let xdata = []
        data.forEach(element => {
          let newdata = {}
          newdata.value = element.code
          newdata.label = element.title
          newdata.id = element.id
          newdata.pcode = element.pcode
          xdata.push(newdata)
        });
        return xdata
      }
    provinceLinkage = async () => {
        const result = await http.get(`/adminapi/administrativedivision?filter=${JSON.stringify({ pcode: 0 })}&op=${JSON.stringify(this.op)}`)
        runInAction(() => {
            this.province = this.cityList(result.data.rows)
        })
    }

    cityLinkage = async (value) => {
        const result = await http.get(`/adminapi/administrativedivision?filter=${JSON.stringify({ pcode: value })}&op=${JSON.stringify(this.op)}`)
        runInAction(() => {
            this.city = this.cityList(result.data.rows)
        })
    }

    countyLinkage = async (value) => {
        const result = await http.get(`/adminapi/administrativedivision?filter=${JSON.stringify({ pcode: value })}&op=${JSON.stringify(this.op)}`)
        runInAction(() => {
            this.county = this.cityList(result.data.rows)
        })
    }

    townshipLinkage = async (value) => {
        const result = await http.get(`/adminapi/administrativedivision?filter=${JSON.stringify({ pcode: value })}&op=${JSON.stringify(this.op)}`)
        runInAction(() => {
            this.township = this.cityList(result.data.rows)
        })
    }

    villageLinkage = async (value) => {
        const result = await http.get(`/adminapi/administrativedivision?filter=${JSON.stringify({ pcode: value })}&op=${JSON.stringify(this.op)}`)
        runInAction(() => {
            this.village = this.cityList(result.data.rows)
        })
    }
}

export { EnterpriseStore }